import jwtService from '@services/jwt.service';
import React, { useRef } from 'react';
import RedirectForm from './RedirectForm';
const RedirectFormLink = ({ children, className, to, onClick, onKeyDown, target = '_blank', ...other }) => {
    const { redirectTo } = to;
    const formRef = useRef(null);
    const handleClick = (event) => {
        if (onClick) {
            onClick(event);
        }
        submitForm();
    };
    const handleKeyDown = (e) => {
        if (onKeyDown) {
            onKeyDown(e);
        }
        if (e.key === 'Enter') {
            submitForm();
        }
    };
    const submitForm = () => {
        // Do not initiate redirection if the token has expired - otherwise a user will
        // be redirected to an incorrect page.
        if (!jwtService.isTokenExpired()) {
            formRef.current.submit();
        }
    };
    return (<span className={className} onClick={handleClick} onKeyDown={handleKeyDown} {...other} data-testid="RedirectFormLink">
            {children}
            <RedirectForm ref={formRef} to={`${redirectTo}`} target={target}/>
        </span>);
};
export default RedirectFormLink;
